import { useEffect, useState, useCallback } from 'react';
import _ from 'lodash';

import { UserActions } from 'BMapsCmds';
import { EventBroker } from 'BMapsSrc/eventbroker';
import { WorkingIndicator } from '../ui_utils';
import TooltipInfo from '../common/TooltipInfo';
import InspectorMessage from './InspectorMessage';

export function DisplayLID({ compound }) {
    const [html, setHtml] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const fetchDiagram = useCallback(async (cmpd) => {
        setIsLoading(true);
        const { html: lidHtml, error } = await UserActions.FetchProLifData({ compound: cmpd });
        if (lidHtml) {
            setHtml(lidHtml);
        } else {
            setErrorMessage(error);
            setHtml('');
        }
        setIsLoading(false);
        // Make sure the scene is redrawn after pausing redisplay (to avoid selection flash).
        // Redraw is necessary because if the user switches compounds with just the right timing,
        // we could end up with a blank screen.
        // May occasionally cause slight delay, but since fetch is debounced, should be fine.
        EventBroker.publish('redrawSceneRequest');
    }, []);

    // Debounce wants a stable function input, and the result should also be a stable function.
    // So useCallback for both.
    /* eslint-disable react-hooks/exhaustive-deps */
    const fetchDiagramDebounced = useCallback(_.debounce(fetchDiagram, 1000), []);
    useEffect(() => {
        fetchDiagramDebounced(compound);
    }, [compound]);
    /* eslint-enable react-hooks/exhaustive-deps */

    if (html) {
        return (
            <ProLIFResults html={html} />
        );
    } else if (errorMessage) {
        return <InspectorMessage>{errorMessage}</InspectorMessage>;
    } else if (isLoading) {
        return (
            <InspectorMessage>
                Loading ligand interaction diagram...
                {' '}
                <WorkingIndicator />
            </InspectorMessage>
        );
    } else {
        return <InspectorMessage>No Diagram Available</InspectorMessage>;
    }
}

function ProLIFResults({ html }) {
    return (
        <div style={{ position: 'relative' }}>
            <ProLIFInfoIcon style={{
                position: 'absolute', right: '0', backgroundColor: 'white', color: 'black',
            }}
            />
            <iframe srcDoc={html} title="ProLIF Ligand Interaction Diagram" width="100%" height="400" />
        </div>
    );
}

export function ProLIFInfoIcon(props) {
    const content = `"ProLIF" ligand interaction diagram from ChemoSim Lab.
    Try zooming, mousing over interaction lines, toggling the interactivity features, and dragging the residues.
    See https://doi.org/10.1186/s13321-021-00548-6 for more information.`;
    return (
        <TooltipInfo title={content} {...props} />
    );
}
